import React from 'react';

const defaultProps = {
    backgroundColor: '#fff',
    height: '6.093',
    width: '8.52',
};

const CheckboxCheckIcon = ({ backgroundColor, height, width }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 8.52 6.093">
        <path d="M3.667,6.093,0,2.426,1.185,1.241,3.667,3.667,7.334,0,8.519,1.185Z" transform="translate(0.001 0)" fill={backgroundColor} />
    </svg>
);

CheckboxCheckIcon.defaultProps = defaultProps;

export default CheckboxCheckIcon;
